let filterTags = [];
currentCategory = "";
class BlogFilter {
    constructor() {
        this.resetFilters = "reset";
    }

    init() {
        document.querySelectorAll('.data-applyFilters').forEach(button => {
            button.addEventListener('click', (evt) => {
                
                if (evt.currentTarget.classList.contains('badge-tags-active')) {
                    
                    evt.preventDefault(); // Prevent default behavior (page refresh)
                    this.removeActiveFilters(evt);  // Call the function to handle the filter    
                }
                else{
                    evt.preventDefault(); // Prevent default behavior (page refresh)
                this.clearCatFilters(evt);  // Call the function to handle the filter
                }
                
            });
        });


        // Attach event listener for the 'remove-active-filter' links
        document.querySelectorAll('.remove-active-filter').forEach(button => {
            button.addEventListener('click', (evt) => {
                evt.preventDefault(); // Prevent default behavior (page refresh)
                this.removeActiveFilters(evt);  // Call the function to handle the filter
            });
        });

    }

    // Method to clear specific category filters
    clearCatFilters(evt) {
        evt.preventDefault(); // Prevent default action (page refresh)
        let url = window.location.pathname;
        const filterValue = evt.currentTarget.dataset.value;

        if (filterValue.includes("blog-")) {
            currentCategory = filterValue;

            // Ensure 'blog-' value is always placed at index 0 in filterTags array
            if (!filterTags.includes(filterValue)) {
                filterTags.unshift(filterValue); // Add 'blog-' filter at the start
            }
        } else {
            // If it's a tag filter, add it to the filterTags array if it's not already present
            if (!filterTags.includes(filterValue)) {
                filterTags.push(filterValue);
            }
        }

        // Update the URL with the selected filters
        this.updateFilters(url);
    }
    removeActiveFilters(evt) {
        evt.preventDefault(); // Prevent default action (page refresh)

        const hrefUrl = evt.currentTarget.querySelector("a")?.getAttribute("href");

        if (!hrefUrl) {
            console.error("No href value found.");
            return;
        }

        // Extract the tags from the href URL
        const hrefFilters = hrefUrl.includes('/tagged/')
            ? hrefUrl.split('/tagged/')[1].split('+')
            : [];


        // Check if the array has only two values and one is related to "blog-"
        if (hrefFilters.length === 1 && hrefFilters.some(tag => tag.startsWith("blog-"))) {
            // Reset the filters (remove both values)
            filterTags = [];
        } else {
            // Otherwise, update filterTags based on hrefFilters
            filterTags = hrefFilters;
        }


        // Update the filters dynamically by calling updateFilters()
        this.updateFilters();
    }


    // Update the URL based on the current filters
    updateFilters() {
        let currenturl = window.location.pathname;
        if (currenturl.includes('/tagged/')) {
            currenturl = currenturl.split('/tagged/')[0];
        }
        let url;
        if (filterTags.length > 0) {
            url = `${currenturl}/tagged/${filterTags.join('+')}`;
        }
        else {
            url = currenturl
        }

        // Render the filtered content without page refresh
        this.renderData(url);
    }

    // Render data by dynamically fetching content based on the filters
    renderData(finalUrl) {
        fetch(finalUrl)
            .then(res => {
                if (!res.ok) {
                    throw new Error(`Network response was not ok: ${res.statusText}`);
                }
                return res.text();
            })
            .then(data => {
                let html = new DOMParser().parseFromString(data, 'text/html');
                let sourceHTML = html.querySelector('#ajaxBlogArticles');

                let dataWrapper = document.querySelector('#ajaxBlogArticles');
                if (dataWrapper && sourceHTML) {
                    // Inject the new content into the page
                    dataWrapper.innerHTML = sourceHTML.innerHTML;
                }

                // Check if a category filter is active, and hide the category card if so
                if (currentCategory) {
                    const categoryCard = document.querySelector(".card-categories");
                    if (filterTags.length > 0) {
                        categoryCard.classList.add("d-none");
                    }
                    else {
                        categoryCard.classList.remove("d-none");
                    }
                }

                // Push the new URL to the browser's history
                history.pushState({ finalUrl }, '', finalUrl);
                if (dataWrapper) {
                    dataWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
    
                // Create a new instance of BlogFilter and bind the event listeners to the new DOM
                const newBlogFilter = new BlogFilter();
                newBlogFilter.init();
            })
            .catch(error => console.error('Fetch error:', error));
    }

}

const blogFilter = new BlogFilter();
blogFilter.init();
